// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import HttpService from 'src/lib/HttpService';

const DEFAULT_USER_TIER_URL = `blobFiles`;

async function post(endpoint?: string, body?: any) {
    return await call('post', endpoint, body);
}

async function call(method: string, endpoint?: string, body?: any) {
    const url = endpoint
        ? `${DEFAULT_USER_TIER_URL}/${endpoint}`
        : DEFAULT_USER_TIER_URL;

    return await HttpService.proxiedApiCall({
        body,
        requestUrl: url,
        type: method,
    });
}

export default {
    async uploadFiles(request: any) {
        const body = request.payload;
        return post('upload', body);
    },
};
